/**
 * ### applyMarkdownFormatting
 *
 * @description
 * Applies markdown formatting (bold or italic) to the currently selected text
 * by wrapping it with the appropriate markdown syntax.
 *
 * @example
 * // Bold formatting
 * applyMarkdownFormatting('b');
 * // Selected text "hello" becomes "*hello*"
 *
 * // Italic formatting
 * applyMarkdownFormatting('i');
 * // Selected text "world" becomes "_world_"
 *
 * @param formatKey - The formatting key: 'b' for bold (*), 'i' for italic (_)
 */
const applyMarkdownFormatting = (formatKey: 'b' | 'i'): void => {
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) return;

  const range = selection.getRangeAt(0);
  const selectedText = range.toString();

  if (!selectedText) return;

  // Determine the markdown wrapper based on the key pressed
  const wrapper = formatKey === 'b' ? '*' : '_';
  const wrappedText = `${wrapper}${selectedText}${wrapper}`;

  // Delete the selected text and insert the wrapped text
  range.deleteContents();
  const textNode = document.createTextNode(wrappedText);
  range.insertNode(textNode);

  // Move cursor to end of inserted text
  range.setStartAfter(textNode);
  range.collapse(true);
  selection.removeAllRanges();
  selection.addRange(range);
};

export default applyMarkdownFormatting;
